export default __webpack_public_path__ + "static/media/wordmark_dark_stacked.79a909c1.png";